var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"contact-bar",attrs:{"flat":"","height":"auto"}},[_c('contact-bar-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }